import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader } from "../components/PageHeader";
import { Loader, EmptyState, Btn } from "../components/Primitives";
import { StatusBadge } from "../components/Badges";
import { Files, Download } from "lucide-react";

export default function DocumentRepository() {
  const [docs, setDocs] = useState(null);
  useEffect(() => { api.get("/documents", { params: { limit: 200 } }).then(r => setDocs(Array.isArray(r.data) ? r.data : (r.data.items || []))); }, []);

  const download = async (d, format = "pdf") => {
    const res = await api.get(`/documents/${d.id}/export?format=${format}`, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a"); a.href = url; a.download = `${d.title.slice(0, 40)}.${format}`; a.click();
  };

  if (!docs) return <Loader />;

  return (
    <div>
      <PageHeader
        title="Document Repository"
        description="All DPDP documents, policies, and generated content in one place."
        testId="documents-page-header"
      />

      {docs.length === 0 ? <EmptyState title="No documents" hint="Documents from the Policy Generator, breach workflow, and vendor clauses will appear here." /> : (
        <div className="bg-white border border-slate-200 rounded-md overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 border-b border-slate-200">
              <tr>{["Title","Type","Version","Status","Tags","Actions"].map(h => <th key={h} className="text-left px-4 py-2.5 text-[10px] font-bold uppercase tracking-[0.15em] text-slate-500">{h}</th>)}</tr>
            </thead>
            <tbody data-testid="documents-table-body">
              {docs.map(d => (
                <tr key={d.id} className="border-b border-slate-100 hover:bg-slate-50">
                  <td className="px-4 py-2.5 font-medium"><Files className="w-3.5 h-3.5 inline text-slate-400 mr-1.5" />{d.title}</td>
                  <td className="px-4 py-2.5 text-slate-600 capitalize">{d.doc_type}</td>
                  <td className="px-4 py-2.5 text-slate-500 text-[11px]">v{d.version}</td>
                  <td className="px-4 py-2.5"><StatusBadge status={d.status} /></td>
                  <td className="px-4 py-2.5 text-[11px] text-slate-500">{(d.tags || []).join(", ")}</td>
                  <td className="px-4 py-2.5 text-right">
                    <Btn size="sm" variant="secondary" data-testid={`document-download-${d.id}`} onClick={() => download(d, "pdf")}><Download className="w-3.5 h-3.5" /> PDF</Btn>
                    <Btn size="sm" variant="secondary" data-testid={`document-download-docx-${d.id}`} className="ml-1" onClick={() => download(d, "docx")}>Word</Btn>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
